export const FEED_INFO_FRAGMENT = `
    info {
        totalCount
    }
`